import axios from "axios";
import axiosRetry from "axios-retry";
import React, { useEffect, useState } from "react";
import { API, api_url, generateAuthHeader } from "../../util/util";
import { Link } from "react-router-dom";
import referenceImage from "../../assets/img/reference.png";
import { Col, Image, Row } from "react-bootstrap";
import logo from "../../assets/img/technologyAudit.png";

axiosRetry(axios, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
});

function Analytics({ title, url, onLoadingComplete }) {
    const [challenges, setChallenges] = useState(null);
    const [loading, setLoading] = useState(true);

    const handleChallenges = async () => {
        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: generateAuthHeader(),
                    "Content-Type": "application/json",
                },
            });
            setLoading(false);
            if (response.status === 200) {
                setChallenges(response.data);
            } else {
                console.error("Unexpected response");
            }
        } catch (error) {
            console.error("Error fetching challenges:", error);
        } finally {
            onLoadingComplete();
        }
    };

    useEffect(() => {
        setLoading(true);
        handleChallenges();
    }, [url]);

    return (
        <div className="technology-audit">
            <h6 className="mb-3">{title}</h6>
            {loading ? (
                <div className="text-center">
                    <div className="spinner-border me-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p>Data is coming soon</p>
                </div>
            ) : (
                challenges && challenges.analysis && challenges.response ? (
                    <div className="">
                        <p>{challenges.response}</p>
                        <h6>References</h6>
                        {challenges.references && challenges.references.length > 0 ? (
                            challenges.references.map((reference, index) => (
                                <a
                                    key={index}
                                    href={reference.url}
                                    title={reference.title}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {reference.url} <Image src={referenceImage} /><br />
                                </a>
                            ))
                        ) : (
                            <p>No references available</p>
                        )}
                    </div>
                ) : (
                    <p>No data available</p>
                )
            )}
        </div>
    );    
}

function AllAnalytics() {
    const [loadingCount, setLoadingCount] = useState(1);
    const urlParams = new URLSearchParams(window.location.search);
    const query = urlParams.get("query");

    const handleLoadingComplete = () => {
        setLoadingCount((prevCount) => prevCount - 1);
    };

    // Array containing titles and respective URLs
    const analyticsData = [
        { title: "ACQUISITIONS", url: `${api_url}/${API.ENDPOINTS.check}?permalink=${query}` },
        { title: "CHALLENGES FACING", url: `${api_url}/${API.ENDPOINTS.challenge}?permalink=${query}` },
        { title: "WHAT MAKES UNIQUE", url: `${api_url}/${API.ENDPOINTS.unique}?permalink=${query}` },
        { title: "DOES HAVE AI PRODUCTS", url: `${api_url}/${API.ENDPOINTS.aiProduct}?permalink=${query}` },
    ];

    return (
        <div>
            <div className="tab-1">
                <h2>Technology Audit</h2>
            </div>
            <Row>
                <Col lg={1} md={1} sm={1} className="p-0 audit-image">
                    <Image src={logo} />
                </Col>
                <Col lg={11} md={11} sm={11}>
                    {analyticsData.map((item, index) => (
                        <Analytics
                            key={index}
                            title={item.title}
                            url={item.url}
                            onLoadingComplete={handleLoadingComplete}
                        />
                    ))}
                </Col>
            </Row>
        </div>
    );
}

export default AllAnalytics;
